

/* BEGIN cycling-backpack-buyer-highlights-20260731 */
;(function () {
  var expected = ["Robust 900D polyester, durable SBS zippers, and secure KAM buckles provide water-repellent, abrasion-resistant construction with quick access to gear.","Adjustable exterior webbing carries a football, basketball, or full-face helmet, while all-over webbing, shoulder-strap D-rings, and a hook-and-loop patch area expand attachment and personalization options.","A top carry handle, adjustable waist belt (up to 55 in), and rescue-whistle buckle support flexible carry and can help attract attention in an emergency."];
  function applyBuyerHighlights() {
    if (window.location.pathname.indexOf('/products/cycling-backpack-seibertron-waterproof-motorcycle') === -1) return;
    var box = document.querySelector('.auto-product__buyer-fit');
    if (!box) return;
    var items = box.querySelectorAll('li');
    if (items.length < 3) return;
    for (var i = 0; i < 3; i += 1) { if (items[i].textContent !== expected[i]) items[i].textContent = expected[i]; }
  }
  applyBuyerHighlights();
  [80, 250, 800, 1800, 4000].forEach(function (delay) { window.setTimeout(applyBuyerHighlights, delay); });
  new MutationObserver(applyBuyerHighlights).observe(document.documentElement, { childList: true, subtree: true });
})();
/* END cycling-backpack-buyer-highlights-20260731 */
